export enum FactureAvoirStatus {
  BROUILLON = "brouillon",
  VALIDEE = "validee",
  ANNULEE = "annulee"
}

export interface FactureAvoirItem {
  id?: number;
  facture_item_id: number;
  designation: string;
  quantite: number;
  prix_unitaire: number;
  total: number;
}

export interface FactureAvoirItemCreate {
  facture_item_id: number;
  designation: string;
  quantite: number;
  prix_unitaire: number;
  total: number;
}

export interface FactureAvoir {
  id: number;
  reference: string;
  date: string;
  client_id: number;
  client_name?: string;
  client_ice?: string;
  client_address?: string;
  facture_id: number;
  facture_reference?: string;
  bon_retour_id?: number;
  bon_retour_number?: string;
  bon_retour_manual?: string;
  motif_retour?: string;
  remarque_retour?: string;
  total_ht: number;
  remise: number;
  remise_amount: number;
  tva_rate: number;
  tva_amount: number;
  total_net: number;
  status: FactureAvoirStatus;
  user_id: number;
  user_name?: string;
  created_at: string;
  updated_at?: string;
  deleted_at?: string;
  items: FactureAvoirItem[];
}

export interface FactureAvoirCreate {
  date: string;
  client_id: number;
  facture_id: number;
  bon_retour_id?: number;
  bon_retour_manual?: string;
  motif_retour?: string;
  remarque_retour?: string;
  items: FactureAvoirItemCreate[];
}

export interface FactureAvoirUpdate {
  date?: string;
  bon_retour_id?: number;
  bon_retour_manual?: string;
  motif_retour?: string;
  remarque_retour?: string;
  status?: string;
  items?: FactureAvoirItemCreate[];
}

// For dropdown
export interface FactureDropdown {
  id: number;
  reference: string;
  date: string;
  total_net: number;
  status: string;
}

// For dropdown
export interface BonRetourDropdown {
  id: number;
  bon_retour_number: string;
  date: string;
}

// For loading facture items
export interface FactureItemsForAvoir {
  facture_id: number;
  facture_reference: string;
  tva_rate: number;
  remise: number;
  items: {
    id: number;
    designation: string;
    quantite: number;
    prix_unitaire: number;
    total: number;
  }[];
}
